const Login: React.FC = () => {
  return (
    <>
      <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
        <div className='card w-lg-500px p-10'>
          <div className='text-center border-bottom'>
            <div className='text-center mb-5'>
              <h1 className='text-dark fw-bolder uppercase mb-2 fs-4'>Sign In</h1>
            </div>
          </div>
          <div className='card-body'>
            <form className='form w-100'>
              <div className='fv-row mb-8'>
                <label className='form-label fs-6 fw-bolder text-dark'>Mobile Number</label>
                <input
                  placeholder='Phone Number'
                  name='phoneNumber'
                  className='form-control bg-transparent'
                  type='text'
                />
              </div>

              <div className='fv-row mb-8'>
                <label className='form-label fs-6 fw-bolder text-dark'>Enter OTP</label>
                <input
                  placeholder='OTP'
                  name='phoneNumber'
                  className='form-control bg-transparent'
                  type='text'
                />
              </div>

              <button type='button' className='btn btn-primary w-100'>
                Send OTP
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
